import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import request from 'superagent';
import WeatherIcon from 'react-icons-weather';
import { connect } from 'react-redux';
import Slider, { BackgroundImageSlide } from 'base/components/Slider';
import theme, { textBold } from 'theme/theme';
import Flex from 'base/components/Flex';
import MainTitle from 'base/components/MainTitle';
import { getIsAuthenticated, getAuthUser } from 'auth/store/auth/selectors';
import { logout } from 'auth/store/auth/actions';
import SmallLabel from 'base/components/SmallLabel';
import img1 from 'assets/images/welcome/img1.jpg';
import img2 from 'assets/images/welcome/img2.jpg';
import img3 from 'assets/images/welcome/img3.jpg';
import img4 from 'assets/images/welcome/img4.jpg';
import img5 from 'assets/images/welcome/img5.jpg';
import img6 from 'assets/images/welcome/img6.jpg';
import img7 from 'assets/images/welcome/img7.jpg';
import img8 from 'assets/images/welcome/img8.jpg';


const getGreeting = (time) => {
  if (time < 12) {
    return 'Good morning';
  } if (time < 17) {
    return 'Good afternoon';
  } if (time < 24) {
    return 'Good evening';
  }
  return 'Hello';
};

const Greeting = styled(MainTitle)`
  ${textBold};
  color: #fff;
  line-height: 100%;
`;

const DateInfo = styled.div`
  font-size: ${theme.fontSizes.large};
  ${textBold};
  margin-bottom: 40px;
`;

const WeatherInfo = styled.div`
  display: flex;
  align-items: center;
  color: ${theme.colors.medium};
  font-size: ${theme.fontSizes.large};
  ${textBold};
`;

const Wrapper = styled(Flex)`
  position: relative;
  color: #fff;
  text-shadow: 1px 1px 10px rgba(0,0,0,0.4), 1px 1px 2px rgba(0,0,0,0.5);
  flex-direction: column-reverse;
  @media (min-width: ${theme.breakpoints.desktop}) {
    flex-direction: row;
  }

`;

const ContentWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  min-height: 300px;
  padding: 20px;
  @media (min-width: ${theme.breakpoints.desktop}) {
    padding: 30px 40px;
  }
  
`;


class Welcome extends React.Component {
  // eslint-disable-next-line
  images = [img1, img2, img3, img4, img5, img6, img7, img8];

  shuffle = (array) => array.sort(() => 0.5 - Math.random()); // eslint-disable-line

  randomChoice = (array, n) => this.shuffle(array).slice(0, n);

  state = {
    date: new Date(),
    hasWeather: false,
    temperature: null,
    weatherCode: null,
    city: null,
    country: null,
    images: this.randomChoice(this.images, 5),
  };

  componentDidMount() {
    this.dateInterval = setInterval(
      () => this.setState({ date: new Date() }),
      1000,
    );

    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.getWeather(position.coords.latitude, position.coords.longitude);
      },
      () => {},
    );
  }

  componentWillUnmount() {
    clearInterval(this.dateInterval);
  }

  getWeather = (lat, long) => {
    const encodedLocation = `${lat}%2C${long})')%20and%20u%3D'C'`;
    const weatherUrl = `https://query.yahooapis.com/v1/public/yql?q=select%20*%20from%20weather.forecast%20where%20woeid%20in%20(SELECT%20woeid%20FROM%20geo.places%20WHERE%20text%3D'(${encodedLocation}&format=json&callback=`;
    request.get(weatherUrl)
      .then((res) => {
        const { city, country } = res.body.query.results.channel.location;
        const { temp, code } = res.body.query.results.channel.item.condition;
        this.setState({
          hasWeather: true,
          temperature: temp,
          weatherCode: code,
          city,
          country,
        });
      })
      .catch(err => console.log(err)); // eslint-disable-line
  };

  render() {
    const {
      hasWeather, temperature, weatherCode, date, city, country, images,
    } = this.state;
    return (
      <Wrapper>

        <Flex flex="1">
          <Slider>
            {images.map((image) => (
              <BackgroundImageSlide key={image} src={image} />
            ))}
          </Slider>
          <ContentWrapper>
            <Greeting withSpaceBelow>
              {getGreeting(date.getHours())}
            </Greeting>

            <DateInfo>
              It&apos;s
              {' '}
              {dayjs(date).format('dddd, D MMMM YYYY')}
              <br />
              {dayjs(date).format('H:mm')}
              {' '}
              o&apos;clock
            </DateInfo>

            {hasWeather
            && (
            <WeatherInfo>
              {temperature}
                  &deg; C
              <WeatherIcon
                name="yahoo"
                iconId={weatherCode}
                style={{
                  fontSize: '40px',
                  color: theme.colors.medium,
                  margin: '0 0 0 20px',
                }}
              />
            </WeatherInfo>
            )}
            {hasWeather && (
            <SmallLabel>
              {city}
                  ,
              {' '}
              {country}
            </SmallLabel>
            )}

          </ContentWrapper>
        </Flex>


      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: getIsAuthenticated(state),
  user: getAuthUser(state),
});
const mapDispatchToProps = {
  logout,
};


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Welcome);
